module.exports = __webpack_public_path__ + "static/media/aboutBackground.d31dd40d.svg";